/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：271
 */

var r = require(/* 168 */"./168")
module.exports = !r(function () {
  return 7 != Object.defineProperty({}, 1, {
    get: function () {
      return 7
    }
  })[1]
})
